import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { results, PRODUCT } from '../data/content';
export function ResultsSection() {
  return <section aria-labelledby="resultados" className="border-y border-line bg-canvasAlt" data-id="element-225" data-mp="zp7dbiff035k">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-226" data-mp="14o0goi0zmds0">
        <Reveal data-id="element-227" data-mp="14lxrg07nsooc">
          <h2 id="resultados" className="mx-auto max-w-3xl font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-228" data-mp="70s2z978a90k">
            Con {PRODUCT} vas a poder:
          </h2>
          <p className="mt-1 text-sm font-bold uppercase tracking-[0.16em] text-gold" data-id="element-229" data-mp="gyfxpz4u3giq">
            Sin conocimientos previos y a tu propio ritmo
          </p>
        </Reveal>

        <ul className="mx-auto mt-6 grid max-w-5xl gap-2 sm:grid-cols-2" data-id="element-230" data-mp="3kfg32s7cpd2s">
          {results.map((result, i) => <Reveal key={result} as="li" delay={i * 0.02} className="flex items-center justify-center gap-2.5 rounded-xl border border-line bg-surface px-4 py-3 text-sm font-medium text-ink" data-id="element-231" data-mp="3pdzl4hitq4pv" data-mpi={i}>
              <CheckIcon size={15} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-232" data-mp="ta3m38y57ufp" />
              <span data-id="element-233" data-mp="jh6371p8o3gk">{result}</span>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}